// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdvancedSearchController from "./advanced_search_controller"
application.register("advanced-search", AdvancedSearchController)

import AutoOpenModalController from "./auto_open_modal_controller"
application.register("auto-open-modal", AutoOpenModalController)

import ApkManagerController from "./apk_manager_controller"
application.register("apk-manager", ApkManagerController)

import AppIconsPackController from "./app_icons_pack_controller"
application.register("app-icons-pack", AppIconsPackController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HomeScreenLayoutPreviewController from "./home_screen_layout_preview_controller"
application.register("home-screen-layout-preview", HomeScreenLayoutPreviewController)

import IconPickerController from "./icon_picker_controller"
application.register("icon-picker", IconPickerController)

import ImportJobStatusController from "./import_job_status_controller"
application.register("import-job-status", ImportJobStatusController)

import ImportTvChannelController from "./import_tv_channel_controller"
application.register("import-tv-channel", ImportTvChannelController)

import LocationAutocompleteController from "./location_autocomplete_controller"
application.register("location-autocomplete", LocationAutocompleteController)

import MdmCommandModalController from "./mdm_command_modal_controller"
application.register("mdm-command-modal", MdmCommandModalController)

import RangeSliderController from "./range_slider_controller"
application.register("range-slider", RangeSliderController)

import SmartSearchController from "./smart_search_controller"
application.register("smart-search", SmartSearchController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import WebauthnCredentialsController from "./webauthn_credentials_controller"
application.register("webauthn-credentials", WebauthnCredentialsController)
